/*
  Cart drawer add-ons (snippets/pmx-cart-addons.liquid).
  - Option dropdowns: pick the matching variant, swap thumbnail / price / free-shipping note,
    and disable values that are sold out with the other current choices.
  - Add: POST /cart/add with the drawer's sections, then hand the result to the theme's cart
    store (window.xoStore) so the drawer, count bubble and free-shipping bar all re-render.
  Event delegation on document, because the drawer HTML is replaced on every cart change.
*/
(function () {
  if (window.pmxCartAddons) return;
  window.pmxCartAddons = true;

  function variantsOf(row) {
    if (!row._pmxVariants) {
      try {
        row._pmxVariants = JSON.parse(row.querySelector('[data-pmx-addon-variants]').textContent);
      } catch (e) {
        row._pmxVariants = [];
      }
    }
    return row._pmxVariants;
  }

  function choices(row) {
    return Array.from(row.querySelectorAll('[data-pmx-addon-option]')).map(function (s) { return s.value; });
  }

  function matches(v, choice) {
    return choice.every(function (value, i) { return v.options[i] === value; });
  }

  function update(row, changedIndex) {
    var variants = variantsOf(row);
    var selects = Array.from(row.querySelectorAll('[data-pmx-addon-option]'));
    var choice = choices(row);
    var variant = variants.find(function (v) { return matches(v, choice); });

    // The combination is sold out: keep the value just picked and move the others to the first
    // available variant that has it.
    if ((!variant || !variant.available) && changedIndex != null) {
      var alt = variants.find(function (v) { return v.available && v.options[changedIndex] === choice[changedIndex]; });
      if (alt) {
        variant = alt;
        selects.forEach(function (s, i) { s.value = alt.options[i]; });
        choice = alt.options.slice();
      }
    }
    if (!variant) return;

    selects.forEach(function (s, i) {
      Array.from(s.options).forEach(function (opt) {
        var ok = variants.some(function (v) {
          return v.available && v.options[i] === opt.value &&
            v.options.every(function (o, j) { return j === i || o === choice[j]; });
        });
        opt.disabled = !ok;
        opt.textContent = opt.value + (ok ? '' : ' - Sold out');
      });
    });

    var img = row.querySelector('[data-pmx-addon-img]');
    if (img && variant.image) img.src = variant.image;
    var price = row.querySelector('[data-pmx-addon-price]');
    if (price) price.textContent = variant.price;
    var note = row.querySelector('[data-pmx-addon-note]');
    if (note) {
      note.innerHTML = '';
      if (variant.unlocks) {
        var chip = document.createElement('span');
        chip.className = 'pmx-addon__chip';
        chip.textContent = 'Unlocks free shipping';
        note.appendChild(chip);
      }
    }
    var btn = row.querySelector('[data-pmx-addon-add]');
    if (btn) {
      btn.dataset.variantId = variant.id;
      btn.disabled = !variant.available;
      btn.textContent = variant.available ? 'Add' : 'Sold out';
    }
  }

  function sectionIds() {
    var ids = [];
    var mini = document.querySelector('xo-cart-mini');
    if (mini && mini.id) ids.push(mini.id);
    if (window.location.pathname.indexOf('/cart') !== -1) {
      var page = document.querySelector('xo-cart');
      if (page && page.id) ids.unshift(page.id);
    }
    return ids;
  }

  function add(btn) {
    var row = btn.closest('[data-pmx-addon]');
    var variantId = Number(btn.dataset.variantId);
    var wrap = btn.closest('[data-pmx-addons]');
    var source = (wrap && wrap.getAttribute('data-pmx-addons')) || 'drawer';
    if (!variantId || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        // Hidden line property (underscore = not shown in cart or checkout) so orders can be
        // counted as add-on sales: _source = addon-drawer | addon-cart.
        items: [{ id: variantId, quantity: 1, properties: { _source: 'addon-' + source } }],
        sections: sectionIds(),
        section_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (window.xoStore && data.sections) {
          window.xoStore.set('xo-cart', function (prev) {
            return Object.assign({}, prev, {
              size: (prev.size || 0) + 1,
              sections: data.sections,
              items: data.items,
              addIdLoading: '',
              isAdded: true,
              productIdsForCartNotification: [String(row && row.dataset.productId)]
            });
          })('pmx/cartAddon');
        } else {
          window.location.reload();
        }
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Add';
        var msg = (err && (err.description || err.message)) || 'Could not add this item. Please try again.';
        if (window.xoToast) {
          window.xoToast.push({ content: msg, className: 'xo-cart-add-error', placement: 'top-center', delay: 4000 });
        }
      });
  }

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-pmx-addon-option]');
    if (!select) return;
    update(select.closest('[data-pmx-addon]'), Number(select.dataset.pmxAddonOption));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pmx-addon-add]');
    if (!btn) return;
    e.preventDefault();
    add(btn);
  });
})();
